import { isValidPhoneNumber } from 'libphonenumber-js/mobile'

/** Russian numbers are widely written with the `8` trunk prefix, but `+8` is not a calling code. */
export function replaceTrunkPrefix(input: string): string {
  if (!trunkPrefixRegex.test(input) || isValidPhoneNumber(input)) return input

  const replaced = input.replace(trunkPrefixRegex, '+7')

  return isValidPhoneNumber(replaced) ? replaced : input
}

const trunkPrefixRegex = /^\+?8/
